import cn from './cn';
import merge from './merge';
export function getLocale(locale) {
  if (locale) {
    return merge(cn, locale);
  }

  return cn;
}